<template>
  <div class="i-jca-intro">
    <div class="description">
      <div class="header">What is The JobTest Career Accelerator</div>
      <div class="sub">
        The JobTest Career Accelerator is a weekly, live coaching program that combines expert advice, proven job search
        strategies, and real-time feedback — all delivered in a supportive community.
      </div>
      <div class="grad-pill">
        <div class="pill">
          <img :src="iconCheck" />
          <span>Already included with your report package. No extra cost.</span>
        </div>
      </div>
    </div>
    <div class="perks">
      <template
        v-for="perk in PERKS"
        :key="perk.icon"
      >
        <div class="card">
          <img :src="perk.icon" />
          <div class="perk">
            <div class="main">{{ perk.title }}</div>
            {{ perk.text }}
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script setup lang="ts">
// ASSETS
import iconCal from "@/assets/icons/icon-gc-cal.svg"
import iconResume from "@/assets/icons/icon-gc-resume.svg"
import iconRole from "@/assets/icons/icon-gc-role.svg"
import iconInterview from "@/assets/icons/icon-gc-comment.svg"
import iconSalary from "@/assets/icons/icon-gc-cash.svg"
import iconGrowth from "@/assets/icons/icon-gc-spike.svg"
import iconCheck from "@/assets/icons/icon-circle-check-blue.svg"

// CONSTANTS
const PERKS = [
  {
    icon: iconCal,
    title: "Weekly Focus Sessions",
    text: "Each week, join a session led by a real coach get one clear, actionable next step."
  },
  {
    icon: iconResume,
    title: "Resume & LinkedIn Tear‑Downs",
    text: "Watch real-time critiques and apply feedback directly to your own materials."
  },
  {
    icon: iconRole,
    title: "Curated Role Roundup",
    text: "Get support with resumes, interview prep, and get help staying on track."
  },
  {
    icon: iconInterview,
    title: "Interview Drill Circles",
    text: "Practice answers live, hear others, and get coached feedback — no fluff."
  },
  {
    icon: iconSalary,
    title: "Salary & Offer Strategy Clinic",
    text: "Learn what to say (and not say) when negotiating offers or countering salary."
  },
  {
    icon: iconGrowth,
    title: "Application Sprint Workshops",
    text: "Build stronger applications with speed, collaboration, and precision."
  }
]
</script>

<style scoped lang="scss">
.i-jca-intro {
  @include flex(column, start, center, $gap: 50px);

  @media screen and (min-width: $breakpoint-md) {
    gap: 70px;
  }

  .description {
    @include flex(column, start, center, $gap: 18px);

    text-align: center;

    .header {
      @include display-sm;

      font-weight: 700;
    }

    .sub {
      @include text-lg;

      max-width: 860px;
      color: $black700;
    }

    .grad-pill {
      @include border-radius-lg;
      @include text-xxs;

      background-image: $blue-purple-gradient;
      padding: 1px;
      width: fit-content;

      @media screen and (min-width: $breakpoint-sm) {
        @include text-xs;

        font-weight: 600;
      }

      @media screen and (min-width: $breakpoint-md) {
        @include text-sm;
      }

      .pill {
        @include flex(row, start, center, $gap: 8px);
        @include border-radius-lg;

        background-color: white;
        padding: 2px 6px;

        @media screen and (min-width: $breakpoint-sm) {
          padding: 4px 12px;
        }

        img {
          display: none;

          @media screen and (min-width: $breakpoint-xs) {
            display: block;
          }
        }

        span {
          background-image: $blue-purple-gradient;
          color: transparent;
          background-clip: text;
        }
      }
    }
  }

  .perks {
    @include grid($cols: 1fr, $rows: auto, $align-items: center, $gap: 20px);

    text-align: start;

    @media screen and (min-width: $breakpoint-sm) {
      @include grid($cols: repeat(2, 1fr), $rows: repeat(3, auto), $align-items: stretch, $gap: 14px);
    }

    @media screen and (min-width: $breakpoint-md) {
      gap: 20px;
    }

    @media screen and (min-width: $breakpoint-lg) {
      @include grid($cols: repeat(3, 1fr), $rows: repeat(2, auto), $align-items: stretch, $gap: 20px);
    }

    .card {
      @include flex(column, start, start, $gap: 12px);
      @include border-radius-md;

      background-color: $white;
      border: 1px solid $zumthor100;
      padding: 20px;

      .perk {
        @include flex(column, start, start, $gap: 6px);
        @include text-sm;

        color: $black500;

        .main {
          @include text-md;

          color: $black900;
          font-weight: 500;
        }
      }
    }
  }
}
</style>
